import { render, staticRenderFns } from "./IdCardInput.vue?vue&type=template&id=5730dc60"
import script from "./IdCardInput.vue?vue&type=script&lang=js"
export * from "./IdCardInput.vue?vue&type=script&lang=js"
import style0 from "./IdCardInput.vue?vue&type=style&index=0&id=5730dc60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports